import { create } from "zustand";

interface IntakeFormState {
  isSaving: boolean;
  isFormValid: boolean;
  isSubmitting: boolean;
  launchSendToVendor: boolean;
  launchContactName: string;
  launchContactEmail: string;
  launchControlSetIds: string[];
  launchQuestionnaireId: string;
  setIsSaving: (isSaving: boolean) => void;
  setIsFormValid: (isValid: boolean) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setLaunchSendToVendor: (value: boolean) => void;
  setLaunchContactName: (value: string) => void;
  setLaunchContactEmail: (value: string) => void;
  setLaunchControlSetIds: (ids: string[]) => void;
  setLaunchQuestionnaireId: (id: string) => void;
  resetLaunchStep: () => void;
}

export const useIntakeFormStore = create<IntakeFormState>((set) => ({
  isSaving: false,
  isFormValid: true,
  isSubmitting: false,
  launchSendToVendor: false,
  launchContactName: "",
  launchContactEmail: "",
  launchControlSetIds: [],
  launchQuestionnaireId: "",
  setIsSaving: (isSaving) => set({ isSaving }),
  setIsFormValid: (isFormValid) => set({ isFormValid }),
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setLaunchSendToVendor: (launchSendToVendor) => set({ launchSendToVendor }),
  setLaunchContactName: (launchContactName) => set({ launchContactName }),
  setLaunchContactEmail: (launchContactEmail) => set({ launchContactEmail }),
  setLaunchControlSetIds: (launchControlSetIds) => set({ launchControlSetIds }),
  setLaunchQuestionnaireId: (launchQuestionnaireId) => set({ launchQuestionnaireId }),
  resetLaunchStep: () =>
    set({
      launchSendToVendor: false,
      launchContactName: "",
      launchContactEmail: "",
      launchControlSetIds: [],
      launchQuestionnaireId: "",
    }),
}));
